// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  regionId: __t.u64().primaryKey().name("region_id"),
  name: __t.string(),
  originX: __t.f64().name("origin_x"),
  originY: __t.f64().name("origin_y"),
  originZ: __t.f64().name("origin_z"),
  createdAt: __t.timestamp().name("created_at"),
});
